import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'xm-spark';
import { xmSessionStorage } from '@xmatters/common/utils/xmStorage';
import { COMPLIANCE_DIALOG_SHOWN } from 'pages/UserProfilePage/components/Devices/util';
import DialogBoxPortal from 'components/DialogBoxPortal';

import styles from './SmsComplianceDialog.module.scss';

export default function SmsComplianceDialog({ onClose, updateSessionStorage }) {
  if (updateSessionStorage) {
    xmSessionStorage.setItem(COMPLIANCE_DIALOG_SHOWN, 'true');
  }

  return (
    <DialogBoxPortal
      classes={{
        content: styles.dialogBox,
        wrap: styles.wrap,
      }}
      isOpen
      titleText={<FormattedMessage id="SMS_TERMS_HEADING" />}
      rightButtons={
        <Button onClick={onClose} data-testid="SmsCompliance_Close">
          <FormattedMessage id="CLOSE" />
        </Button>
      }
      onClose={onClose}
      className={styles.complianceDialog}
    >
      <section>
        <div>
          <p>
            <FormattedMessage id="SMS_TERMS_OF_SERVICE_1" />
          </p>
          <p>
            <FormattedMessage id="SMS_TERMS_OF_SERVICE_2" />
          </p>
        </div>
      </section>
      <section>
        <h3>
          <FormattedMessage id="SMS_TERMS_OPT_OUT_HEADING" />
        </h3>
        <div>
          <p>
            <FormattedMessage id="SMS_TERMS_OPT_OUT_TEXT" />
          </p>
        </div>
      </section>
      <section>
        <h3>
          <FormattedMessage id="SMS_TERMS_SUPPORT_HEADING" />
        </h3>
        <div>
          <p>
            <FormattedMessage
              id="SMS_TERMS_SUPPORT_TEXT"
              values={{
                // eslint-disable-next-line react/display-name
                a: chunks => (
                  <a
                    href="https://support.xmatters.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </p>
        </div>
      </section>
      <section>
        <h3>
          <FormattedMessage id="SMS_TERMS_PRICING_HEADING" />
        </h3>

        <p>
          <FormattedMessage
            id="SMS_TERMS_PRICING_TEXT"
            values={{
              // eslint-disable-next-line react/display-name
              a: chunks => (
                <a
                  href="https://www.xmatters.com/policy/message-rates-full-tables/sms-rate-table-2"
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
      </section>
      <section>
        <h3>
          <FormattedMessage id="SMS_TERMS_SUPPORTED_CARRIERS_HEADING" />
        </h3>
        <div>
          <p>
            <FormattedMessage id="SMS_TERMS_SUPPORTED_CARRIERS_TEXT" />
          </p>
        </div>
      </section>
    </DialogBoxPortal>
  );
}

SmsComplianceDialog.displayName = 'SmsComplianceDialog';

SmsComplianceDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  updateSessionStorage: PropTypes.bool,
};

SmsComplianceDialog.defaultProps = {
  updateSessionStorage: false,
};
